export default __webpack_public_path__ + "img/DVC-mpc.6f9b5702.jpg";